<template>
	<!--底部 -->
	<Footer>
		<div class="footer-wrap">
			<div class="footer-inner">
				<div class="fh">
					<div class="logo">
						<img src="../../static/img/logo.png" alt="">
					</div>
					<div class="doc-icon-list">
						<div class="whatsapp contact" @click="onMax">
							<span class="iconfont icon-max"></span>
						</div>
						<div class="whatsapp contact" @click="onWhatapp">
							<span class="iconfont icon-whatsapp"></span>
						</div>
						<div class="telegram contact" @click="onTele">
							<span class="iconfont icon-a-telegram"></span>
						</div>
					</div>
				</div>
				<div class="service-time-wrap">
					<div class="title">
						<span>{{ $t('footer.serverTitle')}}:</span>
					</div>
					<div class="content">
						<span>{{ $t('footer.serverTime')}}</span>
					</div>
				</div>
				<div class="email-wrap">
					<span class="title">Email:</span>
					<span class="content">AuroraMcplayer@yandex.ru</span>
				</div>
				<div class="tech">© Aurora Techinologies Inc.2025</div>
			</div>
		</div>
	</Footer>
	<!-- 底部 -->
</template>

<script>
	export default {
		components: {},
		name: 'tvFooter',
		data() {
			return {

			};
		},
		computed: {},
		methods: {
			onTele() {
				const username = 'AuroraMCPlayer'
				const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
				const webUrl = `https://t.me/${username}`

				// 桌面端直接打开网页版
				if (!/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
					return window.open(webUrl, '_blank')
				}

				// iOS 使用隐藏iframe方案
				if (isIOS) {
					const iframe = document.createElement('iframe')
					iframe.style.cssText = 'display:none;width:0;height:0;'
					iframe.src = `tg://resolve?domain=${username}`
					document.body.appendChild(iframe)

					setTimeout(() => {
						document.body.removeChild(iframe)
						if (!document.hidden) {
							// 如果App未安装，跳转网页版
							window.location.href = webUrl
						}
					}, 300)
				} else {
					window.location.href = `tg://resolve?domain=${username}`
					setTimeout(() => {
						if (!document.hidden) window.open(webUrl, '_blank')
					}, 400)
				}
			},
			onWhatapp() {
				const webUrl = 'https://wa.me/79315988108'

				const hiddenLink = document.createElement('a')
				hiddenLink.style.display = 'none'
				hiddenLink.href = webUrl
				hiddenLink.target = '_blank'

				document.body.appendChild(hiddenLink);
				hiddenLink.click()

				setTimeout(() => {
					document.body.removeChild(hiddenLink);
				}, 300)
			},
			onMax() {
				const username = 'AURORA'
				const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
				const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
				const webUrl = `https://web.max.ru/${username}`

				// 桌面端直接打开网页版
				if (!isMobile) {
					window.open(webUrl, '_blank')
					return
				}

				const maxAppUrl = `max://chat?username=${username}`

				if (isIOS) {
					const iframe = document.createElement('iframe')
					iframe.style.cssText = 'display:none;width:0;height:0;'
					iframe.src = maxAppUrl
					document.body.appendChild(iframe)

					setTimeout(() => {
						document.body.removeChild(iframe)
						// 如果 App 未安装，跳转网页版
						if (!document.hidden) {
							window.location.href = webUrl
						}
					}, 300)
				} else {
					// Android 直接尝试跳转
					window.location.href = maxAppUrl
					setTimeout(() => {
						if (!document.hidden) {
							window.open(webUrl, '_blank')
						}
					}, 400)
				}
			}
		},
		created() {

		},
		mounted() {

		},
		updated() {},
	}
</script>
<style lang='less' scoped>
	// 底部
	.footer-wrap {
		width: 100%;
		background: #051412;
		font-family: 'Alibaba PuHuiTi R';

		.footer-inner {
			max-width: 1280px;
			margin: 0 auto;
			padding: 40px 24px 80px;

			.fh {
				display: flex;
				justify-content: space-between;
				color: #fff;

				.doc-icon-list {
					display: flex;

					.contact {
						cursor: pointer;
						color: #fff;
						padding-left: 16px;

						.iconfont {
							font-size: 32px;
						}
					}
				}
			}

			.service-time-wrap {
				padding-top: 26px;

				.title {
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-weight: 400;
					font-size: 14px;
					color: #FFFFFF;
					line-height: 14px;
				}

				.content {
					span {
						font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
						font-weight: 400;
						font-size: 14px;
						color: #7A8599;
						padding-top: 8px;
					}
				}
			}

			.email-wrap {
				padding-top: 24px;

				.title {
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-weight: 400;
					font-size: 14px;
					color: #FFFFFF;
					line-height: 14px;
				}

				.content {
					padding-left: 5px;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-weight: 400;
					font-size: 14px;
					color: #7A8599;
				}
			}

			.tech {
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 400;
				font-size: 14px;
				color: #7A8599;
				padding-top: 22px;
			}
		}
	}

	@media (max-width: 768px) {
		.fh {
			flex-direction: column;
		}

		.doc-icon-list {
			padding-top: 20px;
		}

		.contact {
			padding-left: 0 !important;
			padding-right: 13px;
		}
	}
</style>
